import React, { HTMLAttributes, useEffect, useMemo } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks, Util } from "@xt/xtbase";
const { useTranslation } = Hooks;
import store from "store";
const { Big, getUrl } = Util;
import { Popover } from "antd";

import styles from "./index.module.scss";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Main: React.FC<Props> = ({ className }) => {
  const t = useTranslation();
  const { isLogin, userVipInfo } = store.user;

  const vipInfoLab = useMemo(() => {
    if (!userVipInfo) return {};

    return {
      taker:
        Big(userVipInfo.takerFeeRate || 0)
          .times(100)
          .toFixed(4) + "%",
      maker:
        Big(userVipInfo.makerFeeRate || 0)
          .times(100)
          .toFixed(4) + "%",
    };
  }, [userVipInfo]);

  useEffect(() => {
    if (isLogin && !userVipInfo) {
      store.user.getUserVipInfo();
    }
  }, [isLogin]);

  if (!isLogin || !userVipInfo)
    return (
      <a href={getUrl("/rate")} className={cx("linkClear", className)}>
        {t("trade.fee")}
      </a>
    );

  return (
    <Popover
      overlayClassName={styles.popover}
      content={
        <div className={styles.ul}>
          <div>
            <div>
              <span>{t("trade.yourVipLevel")}:</span>
              <span className={styles.vip}>{userVipInfo.vipName}</span>
            </div>
          </div>
          <div>
            <div>Taker:</div>
            <div>{vipInfoLab.taker}</div>
          </div>
          <div>
            <div>Maker:</div>
            <div>{vipInfoLab.maker}</div>
          </div>
        </div>
      }
      title={
        <div className={styles.title}>
          <span>{t("trade.fee")}</span>
          <a href={getUrl("/rate")} className={cx(styles.link)}></a>
        </div>
      }
    >
      <button className={cx("btnTxt", className, styles.trigger)}>{t("trade.fee")}</button>
    </Popover>
  );
};

export default observer(Main);
// export default Main;
